<template>
  <!-- 智慧学答题作答通用模版 -->
  <div class="answer-exercise-container dialog-exercise" v-if="isTrue">
    <div class="answer-exercise-content" :style="styleObject">
      <div class="stem" v-html="dataIng.topic"></div>
      <div class="stem" v-html="dataIng.subtitle" v-if="dataIng.subtitle"></div>
      <div class="options-box">
        <el-radio-group v-model="userAnswerIndex">
          <div
            class="options flex-between"
            v-for="(item, index) in dataIng.option"
            :key="index"
          >
            <el-radio :label="index">{{ index | optionText }}</el-radio>
            <div
              class="item"
              :style="{ width: 405 + 'px' }"
              v-html="item"
              @click="onChangeAnswer(index)"
              :class="{ c_40B8EE: userAnswerIndex == index }"
            ></div>
          </div>
        </el-radio-group>
      </div>
    </div>
    <div class="footer-box">
      <div class="footer">
        <el-button type="primary" round @click="onLast" v-if="false"
          >上一题</el-button
        >
        <el-button type="danger" round v-if="false">确认完成</el-button>
        <el-button type="primary" round @click="onNext">{{
          buttonText
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/dialog.css";
export default {
  name: "ziHuiXueAnswerExercise",
  data() {
    return {
      isTrue: false,
      dataIng: {},
      tabList: [],
      index: 0,
      userAnswerIndex: -1,
      buttonText: "进入下一题",
      userExercise: [],
      styleObject: { height: "300px" },
    };
  },
  props: {
    exerciseList: Array,
    form: Object,
    height: String,
  },
  watch: {
    exerciseList() {
      this.init();
    },
    dataIng(){
      this.mathJaxInit();
    },
  },
  created() {
    this.styleObject.height = this.height || "300px";
    this.isForm = false;
    this.init();
  },
  filters: {
    optionText(i) {
      let data = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
      return data[i] + ".";
    },
  },
  methods: {
    init(){
      if(this.exerciseList.length==0){
        return false;
      }
      this.buttonText = "进入下一题";
      this.index = 0;
      this.isForm = false;
      this.dataIng = this.exerciseList[this.index];
      this.mathJaxInit();
      this.isTrue = Object.keys(this.dataIng).length > 0;
    },
    onLast() {},
    onNext() {
      if (this.isForm) {
        this.$message.warning("提交频率过快");
        return false;
      }
      if (this.userAnswerIndex === -1) {
        this.$message.warning("请选择答案再下一步");
        return false;
      }
      let auswer = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
      this.userExercise.push({
        user_answer: auswer[this.userAnswerIndex],
        question_id: this.dataIng.question_id,
      });
      if (this.index < this.exerciseList.length - 1) {
        ++this.index;
        this.userAnswerIndex = -1;
        this.dataIng = this.exerciseList[this.index];
        this.buttonText = this.index === 4 ? "确认提交" : "进入下一题";
      } else {
        this.onLoading();
        this.postRequest(
          "/wenjiaoopne/kc/user/question/setIntelligenceNote",
          Object.assign(this.form, {
            user_question: JSON.stringify(this.userExercise),
          })
        )
          .then((result) => {
            this.loading.close();
            this.isForm = true;
            this.userExercise = [];
            this.$emit("submitCallBack", result);
          })
          .catch(() => {
            this.loading.close();
          });
      }
      this.$emit("nextCallBack", this.index);
    },
    mathJaxInit() {
      setTimeout(() => {
        this.$nextTick(function() {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("question-id"); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
    onChangeAnswer(i) {
      this.userAnswerIndex = i;
      // this.userAnswer[this.index] = i;
      // let auswer = ["A", "B", "C", "D"];
      // this.exerciseList[this.index].userAnswer = auswer[i];
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.answer-exercise-container .title {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.answer-exercise-container .title .title-item {
  width: 30px;
  height: 30px;
  background-color: #b1b1b1;
  margin: 0 10px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.answer-exercise-content {
  overflow-y: auto;
}
.answer-exercise-content .stem {
  padding-bottom: 5px;
}
.answer-exercise-content .explain-box {
  width: 100%;
  margin-top: 20px;
}
.answer-exercise-content .explain {
  margin-top: 5px;
}
.answer-exercise-content .options {
  width: 100%;
  position: relative;
  margin: 4px 0;
  cursor: pointer;
}
.answer-exercise-content .item {
  display: inline-block;
  padding: 15px 5px;
  line-height: 20px;
}
.answer-exercise-content .options:hover {
  box-shadow: 0px 1px 10px #f0f0f0;
}
.answer-exercise-content .footer-box {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.answer-exercise-container .footer {
  text-align: center;
  margin: 20px auto 0 auto;
}
.answer-exercise-content .m-10 {
  margin: 0 10px;
}
.answer-exercise-content .success {
  background-color: #6fe7b3;
  color: #fff;
}
.answer-exercise-content .error {
  background-color: #f76570;
  color: #fff;
}
.c_40B8EE {
  color: #40b8ee;
}
</style>
